import { PixelmateBanner} from "./modules/PixelmateBanner";

// Banner initialisieren sobald das DOM bereit ist
function initializeBanner() {
    if (typeof window.pixelmateConfig !== 'undefined' && !window.pixelmateBanner) {
        window.pixelmateBanner = new PixelmateBanner();
    }
}

// Falls DOM bereits geladen ist, sofort initialisieren
if (document.readyState === 'loading') {
    // DOM lädt noch, Event Listener registrieren
    document.addEventListener('DOMContentLoaded', initializeBanner);
} else {
    // DOM bereits geladen, sofort initialisieren
    initializeBanner();
}

// Erlaubt Aufrufern, die das Bundle bereits geladen haben (z. B. die Live-
// Vorschau in den Design-Einstellungen, siehe assets/admin/js/pixelmate-
// design-templates.js), das Banner mit einer neuen window.pixelmateConfig neu
// zu erzeugen, ohne das Script erneut per <script>-Tag einzubinden.
window.pixelmateReinit = function () {
    window.pixelmateBanner = new PixelmateBanner();
};
